module.exports = __webpack_public_path__ + "img/education.e7970209.jpg";